<template>
  <main class="migration-page">
    <section class="migration-hero">
      <div class="brand-mark">新民晚报 · 读者俱乐部</div>
      <div class="brand-mark">由衷感谢读者们的信任和认可，我们会做的更好！</div>
      <div class="hero-badge">服务号 → 小程序</div>
      <h1>迁移旧账户积分</h1>
      <p>
        完成一次身份核验，即可把原服务号账户信息、积分、权益服务（权益服务未过期并未使用的，会自动折算成相应积分）迁移转入小程序。
      </p>
    </section>

    <section class="launch-card">
      <MiniProgramLauncher />
    </section>

    <section class="steps-card">
      <h2>积分迁移教程</h2>
      <ol>
        <li>
          <span>1</span>
          <div>
            <strong>进入小程序</strong>
            <p>请在微信搜索“新民晚报读者俱乐部”，或长按识别小程序码。</p>
          </div>
        </li>
        <li>
          <span>2</span>
          <div>
            <strong>完成登录/注册</strong>
            <p>使用手机号登录“新民晚报读者俱乐部”小程序</p>
          </div>
        </li>
        <li>
          <span>3</span>
          <div>
            <strong>找到迁移入口</strong>
            <p>进入“会员”入口 ➔ “权益与互动” ➔ 点击“数据迁移”。</p>
          </div>
        </li>
        <li>
          <span>4</span>
          <div>
            <strong>核验旧账户</strong>
            <p>填写服务号留存的手机号。</p>
          </div>
        </li>
        <li>
          <span>5</span>
          <div>
            <strong>核对积分与资料</strong>
            <p>确认原积分、账户资料及权益折算积分。</p>
          </div>
        </li>
        <li>
          <span>6</span>
          <div>
            <strong>完成短信验证</strong>
            <p>输入短信验证码并确认迁移，每个账户仅可迁移一次。</p>
          </div>
        </li>
      </ol>
    </section>

    <section class="services-card">
      <h2>迁移后可继续使用</h2>
      <div class="service-grid">
        <div><strong>每日签到</strong><span>签到赚积分</span></div>
        <div><strong>积分兑换</strong><span>积分兑好礼</span></div>
        <div><strong>活动报名</strong><span>查看读者活动</span></div>
        <div><strong>祝福语</strong><span>传递暖心祝福</span></div>
        <div><strong>会员权益</strong><span>查看专属服务</span></div>
        <div><strong>幸运抽奖</strong><span>使用积分参与</span></div>
      </div>
    </section>
    <Footer />
  </main>
</template>

<script>
import Footer from "@/components/util/Footer.vue";
import MiniProgramLauncher from "@/components/MiniProgramLauncher";
import { trackMigrationEvent } from "@/utils/migrationCampaign";

export default {
  name: "AppShow",
  components: { Footer, MiniProgramLauncher },
  mounted() {
    trackMigrationEvent("tutorial_view", {
      service: this.$route.query.service || "",
    });
  },
};
</script>

<style lang="less" scoped>
.migration-page {
  min-height: 100%;
  padding: 24px 16px 48px;
  box-sizing: border-box;
  overflow-y: auto;
  color: #2b211e;
  background: linear-gradient(180deg, #fff0e9 0, #f7f7f7 420px);
}

.migration-hero,
.launch-card,
.steps-card,
.services-card,
.help-card {
  width: 100%;
  max-width: 680px;
  margin: 0 auto 18px;
  box-sizing: border-box;
}

.brand-mark {
  color: #9d241d;
  font-size: 14px;
  font-weight: 700;
}

.hero-badge {
  display: inline-flex;
  margin-top: 22px;
  padding: 7px 13px;
  border-radius: 999px;
  color: #b9231a;
  background: #ffe0d7;
  font-size: 13px;
  font-weight: 700;
}

h1 {
  margin: 16px 0 8px;
  font-size: 30px;
  line-height: 1.3;
}

.migration-hero p,
.launch-card > p,
.help-card p {
  margin: 0;
  color: #756762;
  font-size: 16px;
  line-height: 1.75;
}

.launch-card,
.steps-card,
.services-card,
.help-card {
  padding: 24px 20px;
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(79, 40, 29, 0.07);
}

h2 {
  margin: 0 0 10px;
  font-size: 21px;
}

.launch-card .mini-launcher {
  margin-top: 18px;
}

.launch-card {
  border: 2px solid #efc0b5;
  box-shadow: 0 12px 32px rgba(183, 31, 24, 0.16);
}

ol {
  margin: 0;
  padding: 0;
  list-style: none;
}

li {
  padding: 14px 0;
  display: flex;
  gap: 14px;
  border-bottom: 1px solid #f0e9e6;
  align-items: center;
}

li:last-child {
  border-bottom: 0;
}

li > span {
  width: 34px;
  height: 34px;
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  background: #d42a20;
  font-weight: 700;
}

li strong {
  font-size: 17px;
}

li p {
  margin: 5px 0 0;
  color: #776b66;
  font-size: 18px;
  line-height: 1.6;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.service-grid div {
  min-height: 82px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #f0d7d0;
  border-radius: 16px;
  background: #fff9f6;
}

.service-grid strong {
  font-size: 16px;
}

.service-grid span {
  margin-top: 6px;
  color: #85746e;
  font-size: 13px;
}

.help-card a {
  min-height: 48px;
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  color: #fff;
  background: #d42a20;
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
}
</style>
